import React, { useState } from 'react';
import { bool, func } from 'prop-types';
import {
  ModalStyled,
  ModalActionsStyled,
  RadioSetStyled,
  RadioStyled,
  TextStyled,
  ButtonStyled,
  Box,
  useTokens
} from '@nike/nike-design-system-components';

import LoadingAnimation from '../../../../components/LoadingAnimation';

const DuplicateCatalogModal = ({ isOpen, closeModal, duplicateCatalog, isDuplicating }) => {
  const tokens = useTokens();

  const [includeProducts, setIncludeProducts] = useState(null);

  return (
    <ModalStyled
      isOpen={isOpen}
      closeModal={closeModal}
      title=''
      modalRootCompProps={{ style: { maxWidth: '804px' } }}
      modalHeaderCompProps={{ style: { paddingBottom: '0' } }}
      backdropCompProps={{ style: { backdropFilter: 'blur(4px)' } }}
      slots={{
        HeaderTitleSlot: (
          <Box
            width='140%'
            paddingBlockEnd='12px'
            style={{ borderBottom: `1px solid ${tokens.podiumCdsColorGrey300}` }}
          >
            <TextStyled appearance='title2'>Duplicate Catalog</TextStyled>
            <TextStyled appearance='body1Strong' color={tokens.podiumCdsColorGrey500}>
              The duplicated catalog will have a unique Catalog ID, Created Date, and Owner.
            </TextStyled>
          </Box>
        ),
        FooterSlot: (
          <ModalActionsStyled>
            <ButtonStyled
              type='submit'
              appearance='primary'
              onClick={() => duplicateCatalog(includeProducts)}
              disabled={includeProducts === null}
            >
              Duplicate
            </ButtonStyled>
            <ButtonStyled type='button' appearance='secondary' onClick={closeModal}>
              Cancel
            </ButtonStyled>
          </ModalActionsStyled>
        )
      }}
    >
      <Box width='100%' height='100%'>
        <Box paddingBlockEnd='10px' paddingBlockStart='10px'>
          <Box paddingBlockEnd='30px'>
            <RadioSetStyled
              legend=''
              name='includeProducts'
              onChange={e => setIncludeProducts(e.target.value)}
              selectedValue={includeProducts}
            >
              <RadioStyled id='includeAllProducts-radioButton' label='Include All Products' value='true' />
              <RadioStyled id='noProductsIncluded-radioButton' label='No Products Included' value='false' />
            </RadioSetStyled>
          </Box>
          <TextStyled style={{ fontSize: '16px' }}>Do you want to proceed with duplicating this catalog?</TextStyled>
        </Box>
      </Box>
      {isDuplicating && (
        <Box
          data-testid='duplicating-overlay'
          width='100%'
          height='67%'
          style={{
            position: 'absolute',
            top: '29%',
            left: '0',
            background: 'rgba(255, 255, 255, 0.7)',
            zIndex: '3'
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '28%',
              left: '36%'
            }}
          >
            <TextStyled width='100%' appearance='title4'>
              DUPLICATING CATALOG...
            </TextStyled>
          </div>

          <LoadingAnimation size='s' />
        </Box>
      )}
    </ModalStyled>
  );
};

DuplicateCatalogModal.propTypes = {
  isOpen: bool.isRequired,
  closeModal: func.isRequired,
  duplicateCatalog: func.isRequired,
  isDuplicating: bool.isRequired
};

export default DuplicateCatalogModal;
